const TOKEN_STORAGE_KEY = 'tavern_token';
const RECONNECT_DELAY_MS = 5000;

export const parseServerEventChunks = (buffer, chunk, onEvent) => {
  const nextBuffer = `${buffer}${chunk}`;
  const frames = nextBuffer.split(/\r?\n\r?\n/);
  const remainder = frames.pop() || '';

  frames.forEach((frame) => {
    const dataLines = frame
      .split(/\r?\n/)
      .filter((line) => line.startsWith('data:'))
      .map((line) => line.replace(/^data:\s?/, ''));

    if (dataLines.length === 0) return;

    try {
      const event = JSON.parse(dataLines.join('\n'));
      if (event.type !== 'connected') {
        onEvent(event);
      }
    } catch {
      // Ignore malformed payloads; the next valid event will refresh the UI.
    }
  });

  return remainder;
};

export const openTavernEventStream = (onEvent) => {
  const token = window.localStorage.getItem(TOKEN_STORAGE_KEY);

  if (!token || typeof window.fetch !== 'function' || typeof AbortController === 'undefined') {
    return null;
  }

  let closed = false;
  let reconnectTimeoutId = null;
  let abortController = null;

  const scheduleReconnect = () => {
    if (closed) return;

    window.clearTimeout(reconnectTimeoutId);
    reconnectTimeoutId = window.setTimeout(connect, RECONNECT_DELAY_MS);
  };

  const connect = async () => {
    abortController = new AbortController();

    try {
      const response = await window.fetch('/api/events/stream', {
        headers: {
          Accept: 'text/event-stream',
          Authorization: `Bearer ${token}`,
        },
        signal: abortController.signal,
      });

      if (!response.ok || !response.body?.getReader) {
        scheduleReconnect();
        return;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (!closed) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer = parseServerEventChunks(buffer, decoder.decode(value, { stream: true }), onEvent);
      }

      if (!closed) {
        scheduleReconnect();
      }
    } catch (error) {
      if (!closed && error?.name !== 'AbortError') {
        scheduleReconnect();
      }
    }
  };

  connect();

  return {
    close() {
      closed = true;
      window.clearTimeout(reconnectTimeoutId);
      abortController?.abort();
    },
  };
};
